import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';

import { BuyPersonaliseBtn, QuantityInput } from '../styles';
import { SpinnerLoader } from '../styles';
import { forEach, remove, times } from 'lodash';
import uuid from 'react-uuid';

const isModalOpen = () =>
  !!document.getElementById('modalAddToCartProduct').classList.contains('show');

const BuyBtn = ({
  selection,
  limit,
  products,
  personalisationSelected,
  handleShowMessages,
  selectionStage,
  isMobile,
  isMini,
}) => {
  const Btn = useRef(null);
  const Interval = useRef(null);
  const [efbEdit, setEFBEdit] = useState(editSelector ? true : false);
  const [selectorQuantity, setSelectorQuantity] = useState(
    editSelector ? editSelector.quantity : 1
  );
  const [building, setBuilding] = useState(false);
  const [uid, setUid] = useState(0);

  useEffect(() => {
    // * watch for first change in cart drawer and set efb state to false
    const handleMutation = () => {
      if (efbEdit) {
        setEFBEdit(false);
        observer.disconnect();
      }
    };
    const observer = new MutationObserver(handleMutation);
    observer.observe(document.querySelector('.tt-cart-content'), {
      childList: true,
      subtree: true,
    });
  }, []);

  useEffect(() => {
    if (building) {
      Interval.current = setInterval(() => {
        isModalOpen()
          ? (clearInterval(Interval.current), setBuilding(false))
          : null;
      }, 500);
      return () => clearInterval(Interval.current);
    }
  }, [building]);

  const bundleFull = () => {
    let x = selection.filter((item) => item !== null);
    return x.length === limit ? true : false;
  };

  const getCurrentDate = () => {
    let date = new Date();

    let rDate = `${date.getFullYear()}${date.getMonth()}${date.getDate()}${date.getHours()}${date.getMinutes()}${date.getSeconds()}`;

    return rDate;
  };

  const getParentId = () => {
    return (products.bundle_name === 'REG_OBJ' && limit == 6) ||
      (products.bundle_name === 'MINI_OBJ' && limit == 12)
      ? parseInt(products.bundle_parent_products.small)
      : parseInt(products.bundle_parent_products.large);
  };

  // * update Unique ID on buy button every time the limit is reached
  useEffect(() => {
    selection.filter((item) => item).length === limit ? setUid(uuid()) : null;
  }, [selection]);

  const handleQuantityInput = (e) => {
    setSelectorQuantity(e.target.value);
  };

  const handleQuantityChange = (operation) => {
    if (operation === 'dec') {
      selectorQuantity > 1 ? setSelectorQuantity(selectorQuantity - 1) : null;
    } else {
      setSelectorQuantity(selectorQuantity + 1);
    }
  };

  const checkCart = (id, nProps, historicalCart) => {
    const checkProps = (hItems) => {
      let g = {};
      const propNames = Object.keys(nProps);

      for (let item of hItems) {
        let tracker = [];
        let hProps = item.properties;
        let quantity = item.quantity;
        propNames.forEach((propName) => {
          if (
            hProps.hasOwnProperty(propName) &&
            typeof hProps[propName] !== 'object' &&
            hProps[propName] === nProps[propName]
          ) {
            tracker.push(0);
          } else if (
            hProps.hasOwnProperty(propName) &&
            typeof hProps[propName] === 'object' &&
            JSON.stringify(hProps[propName].sort()) ===
              JSON.stringify(nProps[propName].sort())
          ) {
            tracker.push(0);
          }
        });
        if (tracker.length === propNames.length) {
          g = {
            price: hProps['_total'],
          };
          break;
        } else {
          g = false;
        }
      }
      return g;
    };

    if (historicalCart.length) {
      let filteredItems = historicalCart.filter((item) => item.id === id);
      if (filteredItems) {
        return checkProps(filteredItems);
      } else return false;
    } else {
      return false;
    }
  };

  const getSelectorType = (selection) => {
    const vItems = selection.filter((selectionItem) => {
      return selectionItem.title.toLowerCase().includes('vegan') ? true : false;
    });
    const gfItems = selection.filter((selectionItem) => {
      return selectionItem.title.toLowerCase().includes('gluten free')
        ? true
        : false;
    });

    return gfItems && gfItems.length === selection.length && !vItems.length
      ? 'GF'
      : vItems && vItems.length === selection.length && !gfItems.length
      ? 'Vegan'
      : gfItems.length && vItems.length
      ? 'Mixed GF and Vegan'
      : gfItems.length && !vItems.length
      ? 'Mixed GF'
      : vItems.length && !gfItems.length
      ? 'Mixed Vegan'
      : 'Non GF';
  };

  const addToBasket = async (e) => {
    if (Btn.current.classList.contains('disabled')) {
      e.stopPropagation();
      return;
    } else {
      setBuilding(true);
      // * set in a timeout to account for themes UGI function
      let hcRes = await axios.get('/cart.json');
      let historicalCart = await hcRes.data.items;
      let selector_id = getParentId();

      // let timestamp = getCurrentDate();

      let c = {};
      let productIds = selection.map((item) => {
        return item.id || item.variantID;
      });

      // forming new properties OBJ

      let uniqueVariants = productIds.filter((id, index, arr) => {
        return index === arr.indexOf(id);
      });

      let childProperties = selection.reduce((acc, item) => {
        let z = [];
        let y = acc.find((storedItem) => {
          return (
            (storedItem.child_id === item.id ||
              storedItem.child_id === item.variantID) &&
            storedItem.personalisation === item.message
          );
        });

        y ? acc.splice(acc.indexOf(y), 1) : null;
        let t = y
          ? { ...y, child_qty: (y.child_qty += 1) }
          : {
              child_id: item.variantID || item.id,
              child_product_id: item.productID,
              ...(item?.limitedAvailability
                ? { child_availability: item.limitedAvailability }
                : {}),
              child_name: item.title,
              child_qty: 1,
              child_price: item.price,
              img: item.img,
              personalisation: item.message ? item.message : null,
            };

        z.push(t);
        return [...acc, ...z];
      }, []);

      let properties = {};
      properties['_Parent Personalisation Message'] = childProperties.find(
        (childProp) => childProp.personalisation
      )
        ? true
        : false;
      properties['_Selector Type'] = getSelectorType(selection);
      properties['_uid'] = uid;
      properties._children = JSON.stringify(childProperties);

      const checkStrMatch = (array, productName) => {
        let match = array.find(
          (str) => str.trim() !== '' && str.includes(productName)
        );

        return match ? true : false;
      };

      let str = childProperties.reduce((str, prop, index, arr) => {
        const strArr = str ? str.split('|') : null;
        // * check if item with same title alredy in string
        if (strArr?.length && checkStrMatch(strArr, prop.child_name)) {
          // * multiple instances of the same product with personalisations need to be grouped into one TITLE * QUANTITY entry

          let x = strArr
            .filter((val) => val.trim() !== '')
            .map((str) => {
              if (str.includes(prop.child_name)) {
                let nQty =
                  parseInt(str.replace(/[^0-9]/g, '')) +
                  parseInt(prop.child_qty);
                return `${prop.child_name} x ${nQty}${
                  index !== arr.length - 1 ? '|' : ''
                }`;
              } else return `${str}${index !== arr.length - 1 ? '|' : ''}`;
            });
          str = x.join('|');
        } else {
          str += `${prop.child_name} x ${prop.child_qty}${
            index !== arr.length - 1 ? '|' : ''
          }`;
        }
        return str;
      }, '');
      properties['_Bundle Overview'] = str
        .replaceAll('||', '|')
        .replaceAll('|', ', ');

      let total = 0;

      selection.forEach((product) => {
        total += parseInt(product.price);
      });
      //properties['_total'] = total * quantity;
      properties['_total'] = total;

      properties._bundle_type = isMini ? 'mini' : 'regular';
      let msgProd = products.personalisation_message_item;

      let propsMatch = checkCart(selector_id, properties, historicalCart);

      propsMatch.price ? properties['_total'] : null;

      let finalArr = [
        { id: selector_id, quantity: selectorQuantity, properties: properties },
      ];

      if (efbEdit) {
        // * get 1-based target line
        const params = new URLSearchParams(window.location.search);
        const target = parseInt(params.get('item_edit') + 1);
        // * remove target line from cart
        await axios.post('/cart/change.json', {
          line: target,
          quantity: 0,
        });
        setEFBEdit(false);
      }
      await axios.post('/cart/add.json', { items: finalArr });
      // let data = await res.data;

      // * for getting cart data
      // let cart = await axios('/cart.json');
    }
  };

  return (
    <div className="d-flex justify-content-between align-items-center">
      <QuantityInput $currentQuantity={selectorQuantity}>
        <button
          onClick={() => handleQuantityChange('dec')}
          disabled={selectorQuantity > 1 ? false : true}
        >
          -
        </button>
        <input
          value={selectorQuantity}
          onInput={(e) => handleQuantityInput(e)}
        />
        <button onClick={() => handleQuantityChange('inc')}>+</button>
      </QuantityInput>
      <BuyPersonaliseBtn
        ref={Btn}
        $showPersonalise={personalisationSelected}
        $isMobile={isMobile}
        stage={selectionStage}
        id={uid}
        className={`selector-add-to-cart ${
          selection.filter((item) => item === null).length || building
            ? 'disabled'
            : ''
        }`}
        type="submit"
        disabled={bundleFull() ? false : true}
        onClick={(e) => {
          (!personalisationSelected && selectionStage === 'review') || !isMobile
            ? addToBasket(e)
            : personalisationSelected && selectionStage === 'personalise'
            ? addToBasket(e)
            : handleShowMessages();
        }}
      >
        {!building ? (
          personalisationSelected && selectionStage === 'review' && isMobile ? (
            'personalise'
          ) : efbEdit ? (
            'update'
          ) : (
            'add to basket'
          )
        ) : (
          <SpinnerLoader width={40} height={40} $stroke={'#fff'}>
            <svg
              className="spinner"
              width={`${40}px`}
              height={`${40}px`}
              viewBox="0 0 132 132"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle
                fill="none"
                strokeWidth="8"
                strokeLinecap="round"
                cx="66"
                cy="66"
                r="30"
              ></circle>
            </svg>
          </SpinnerLoader>
        )}
      </BuyPersonaliseBtn>
    </div>
  );
};

export default BuyBtn;
